import React, { useState } from 'react';
import { useDiscoveryContext } from '../context/DiscoveryContext';
import { useStreamingChat } from '../hooks/useStreamingChat';

export default function ChatInput() {
  const { state } = useDiscoveryContext();
  const { sendMessage, isLoading } = useStreamingChat(state.sessionId);
  const [value, setValue] = useState('');

  const disabled = isLoading || !state.sessionId;

  const submit = async () => {
    const trimmed = value.trim();
    if (!trimmed || disabled) return;
    setValue('');
    await sendMessage(trimmed);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      submit();
    }
  };

  return (
    <form
      className="chat-input-area"
      onSubmit={(e) => {
        e.preventDefault();
        submit();
      }}
      data-testid="chat-input-form"
    >
      <input
        type="text"
        className="chat-input"
        placeholder="Tell us about your idea..."
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={handleKeyDown}
        disabled={disabled}
        aria-label="Chat message"
        data-testid="chat-input"
      />
      <button
        type="submit"
        className="chat-submit"
        disabled={disabled || !value.trim()}
        aria-label="Send message"
        data-testid="chat-submit"
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <line x1="5" y1="12" x2="19" y2="12" />
          <polyline points="12 5 19 12 12 19" />
        </svg>
      </button>
    </form>
  );
}
